import { TrainingReviewDetails } from "@/components/training-simulator/review/training-review-details";
import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/training/review/$progressId",
)({
  component: TrainingReviewDetailsComponent,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "training-simulator-reviews");
  },
});

function TrainingReviewDetailsComponent() {
  const { progressId } = Route.useParams();

  return <TrainingReviewDetails progressId={progressId} />;
}
